import * as React from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { Space } from 'v2/components/Shared/Space';
import { useGetSubscriptionPlan } from 'v2/hooks/useGetSubscriptionPlan';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { Breadcrumb } from './Breadcrumb';
import { Form } from './Form';
import { Header } from './Header';

import type IProduct from 'interfaces/IProduct';

type Params = {
  productId: string;
  subscriptionPlanId: string;
};

function SubscriptionPlan() {
  const params = useParams<Params>();
  const location = useLocation<{ product: IProduct }>();

  const planId = Number(params.subscriptionPlanId);
  const product = location.state?.product;
  const isBeta = eduzzAccountsService.verifyUserHasBetaModule('planos_assinatura');

  const plansQuery = useGetSubscriptionPlan(planId, {
    enabled: !!planId && isBeta,
    cacheTime: 0,
  });

  function getTitle() {
    if (planId) {
      return plansQuery.isLoading ? 'Carregando...' : plansQuery.data?.plan_title;
    }

    return 'Cadastro de planos de assinatura';
  }

  const pageTitle = getTitle();

  if (!isBeta || !product?.id) return <Redirect to='/producer/product/myproducts' />;

  return (
    <div>
      <Breadcrumb title={pageTitle} />
      <Space size={20} axis='vertical' />
      <Header title={pageTitle} />
      <Space size={24} axis='vertical' />
      <Form product={product} />
    </div>
  );
}

export { SubscriptionPlan };
